<script>
import CheckboxInput from './formModules/CheckboxInput.vue'
import DateTimeOffset from './formModules/DateTimeOffset.vue'
import TextAreaInput from './formModules/TextAreaInput.vue'
import SpinnerInput from './formModules/SpinnerInput.vue'
import FormTags from './formModules/FormTags.vue'
import BaseText from './formModules/BaseText.vue'
import RangeSlider from './formModules/RangeSlider.vue'
import UploadBox from './formModules/UploadBox.vue'
import Imagecropper from '../../user/ImageCropper.vue'
import ChooseImage from './formModules/ChooseImage.vue'
import SearchComboBox from './formModules/SearchComboBox.vue'
import ComboBox from './formModules/ComboBox.vue'
import Tags from './formModules/Tags.vue'
import MultiSelect from './formModules/MultiSelect.vue'
import Radio from './formModules/Radio.vue'
import CheckBox from './formModules/Checkbox.vue'
import Plaque from './formModules/Plaque.vue'
import TagComboBox from './formModules/TagComboBox.vue'
import ColorPicker from './formModules/colorPicker.vue'
import Price from './formModules/Price.vue'
import axios from 'axios'
import Button from '../Button.vue'
import fileMannager from '../../../services/file'
import userDataProvider from '../../../services/user'
import invoiceDataProvider from '../../../services/invoice'
import moment from 'jalali-moment'

export default {
  props: {
    formData: {
      default: null,
      type: Array,
    },
    inputsData: {
      default: null,
      type: Array,
    },
    hasTitle: {
      default: false,
      type: Boolean,
    },
    sectionBackground: {
      default: false,
      type: Boolean,
    },
    customRangeSlider: {
      default: null,
      type: Array,
    },
    deleteUser: {
      default: false,
      type: Boolean,
    },
    cancleForm: {
      default: false,
      type: Boolean,
    },
    hasBottomMargin: {
      default: true,
      type: Boolean,
    },
    stopLoading: {
      default: null,
      type: Boolean,
    },
  },
  components: {
    BaseText,
    CheckboxInput,
    DateTimeOffset,
    TextAreaInput,
    SpinnerInput,
    RangeSlider,
    FormTags,
    Imagecropper,
    SearchComboBox,
    ComboBox,
    Tags,
    Radio,
    Price,
    CheckBox,
    Button,
    Plaque,
    ColorPicker,
    ChooseImage,
    MultiSelect,
    UploadBox,
    TagComboBox,
  },
  data() {
    return {
      btnLoading: false,
      deactiveUserStatus: false,
    }
  },
  watch: {
    stopLoading(val) {
      if (val === true) {
        this.btnLoading = false
      }
    },
  },
  beforeMount() {
    if (this.$route.name == 'list-user-detail') {
      userDataProvider
        .getUserDetails({
          peopleId: this.$route.params.id,
        })
        .then((res) => {
          this.deactiveUserStatus = res.data.data.peopleGlobalDto.isDeactivate
        })
    }
    this.formData.map((item) => {
      item.sectionData.map((d) => {
        d.components.map((component) => {
          if (component.type == 'ComboBox' && component.name == 'ProvinceId') {
            component.attributes.searchedData = component.attributes.componentData
            let filteredComboData = this.inputsData.find((item) => item.id == component.id)
            if (filteredComboData.value) {
              component.attributes.selectedValue = component.attributes.componentData.find((s) => s.key == filteredComboData.value).value
            }
          }
          if (component.type == 'ChooseImage') {
            let filteredComboData = this.inputsData.find((item) => item.id == component.id)
            if (filteredComboData.value) {
              component.attributes.defaultImage = filteredComboData.value
            }
          }
          if (component.type == 'UploadBox') {
            let filteredComboData = this.inputsData.find((item) => item.id == component.id)
            if (filteredComboData.value) {
              component.attributes.componentData = filteredComboData.value
            }
          }
          if (component.type == 'Plaque') {
            let filteredComboData = this.inputsData.find((item) => item.id == component.id)
            console.log('filteredComboData', filteredComboData);
            if (filteredComboData.value) {
              component.attributes.componentData = filteredComboData.value
            }
          }
          if (component.type == 'TagComboBox') {
            component.attributes.searchedData = component.attributes.componentData
            let filteredComboData = this.inputsData.find((item) => item.id == component.id)
            if (filteredComboData.value) {
              component.attributes.selectedValue = component.attributes.componentData.find((s) => s.key == filteredComboData.value).value
            }
          }
          if (component.type == 'Price') {
            if (this.inputsData.filter((item) => item.id == component.id)[0].value) {
              this.inputsData.filter((item) => item.id == component.id)[0].value = this.inputsData
                .filter((item) => item.id == component.id)[0]
                .value.replace(/\D/g, '')
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
          }
        })
      })
    })
  },
  mounted() {
    this.formData.map((item) => {
      item.sectionData.map((d) => {
        d.components.map((component) => {
          let filteredComboData = this.inputsData.find((item) => item.id == component.id)
          if (component.type == 'ComboBox') {
            axios({
              url: component.relations[0].api,
              method: component.relations[0].apiMethod,
              params: {
                pageSize: 1000,
                pageNumber: 1,
                keyword: '',
                ProvinceId: component.attributes.componentData.find((s) => s.key == filteredComboData.value).key,
              },
            }).then((res) => {
              let city = component.relations.find((el) => el.relationType == 'ComboboxSelect')
              let cityID = this.inputsData.find((item) => item.id == city.id)
              this.formData.map((item2) => {
                item2.sectionData.map((d2) => {
                  d2.components.map((component2) => {
                    if (component2.id == cityID.id) {
                      component2.attributes.componentData = res.data.data
                      component2.attributes.searchedData = res.data.data
                      component2.attributes.selectedValue = component2.attributes.componentData.find((s) => s.key == cityID.value).value
                    }
                  })
                })
              })
            })
          }
        })
      })
    })
  },
  methods: {
    onSubmit(event) {
      this.btnLoading = true
      event.preventDefault()
      this.formData.map((item) => {
        item.sectionData.map((d) => {
          for (let i = 0; i < d.components.length; i++) {
            const element = d.components[i]
            if (element.type == 'Price') {
              let xxx = this.inputsData.filter((item) => item.id == element.id)
              xxx.value = xxx[0].value.replace(/,/g, '')
            }
            if (element.type == 'DateTimeOffset') {
              let xxx = this.inputsData.find((item) => item.id == element.id)
              xxx.value = moment(xxx.value).format()
            }
          }
        })
      })
      setTimeout(() => {
        this.$emit('formSubmited', this.inputsData)
      }, 500)
    },
    deactiveUser() {
      this.deactiveUserStatus == !this.deactiveUserStatus
      setTimeout(() => {
        invoiceDataProvider.deactivePeople({
          peopleId: this.$route.params.id,
          deactiveState: this.deactiveUserStatus,
        })
      }, 100)
    },
    updateRate(e) {
      console.log('e', e)
    },
    fileBoxData(val, x) {
      this.inputsData.find((item) => item.id == x.id).value = val
    },
    plaque(val, x) {
      this.inputsData.find((item) => item.id == x.id).value = val
    },
    imageCropper(event, selected, seletedObject) {
      seletedObject.attributes.cropperLoading = true
      seletedObject.attributes.imageCropperModal = true
      const selectedImage = event
      fileMannager
        .addImage({ base64image: selectedImage })
        .then((res) => {
          selected.value = res.data.data.downloadUrl
          seletedObject.attributes.cropperLoading = false
          seletedObject.attributes.imageCropperModal = false
        })
        .catch((err) => {
          console.log(err)
        })
    },
    cancleButton() {
      window.history.go(-1)
    },
    selectedComboBox(event, relations, defaultValues, mainData) {
      defaultValues.value = event.key
      relations.map((relation) => {
        if (relation.relationType == 'ComboboxSelect') {
          if (relation.apiMethod == 'get') {
            axios({
              url: relation.api,
              method: relation.apiMethod,
              params: {
                pageSize: 1000,
                pageNumber: 1,
                keyword: '',
                ProvinceId: event.key,
              },
            }).then((res) => {
              mainData.map((item) => {
                item.sectionData.map((d) => {
                  d.components.map((component) => {
                    if (component.id == relation.id) {
                      component.attributes.componentData = res.data.data
                      component.attributes.searchedData = res.data.data
                    }
                  })
                })
              })
            })
          } else {
            axios({
              url: relation.api,
              method: relation.apiMethod,
              data: {
                pageSize: 1000,
                pageNumber: 1,
                keyword: '',
                ProvinceId: event.key,
              },
            }).then((res) => {})
          }
        }
      })
    },
    searchedComboBox(event, relations, defaultValues, mainData) {
      relations.map((relation) => {
        if (relation.relationType == 'comboboxSearch') {
          if (!relation.api) {
            mainData.map((item) => {
              item.sectionData.map((d) => {
                d.components.map((component) => {
                  if (component.id == relation.id) {
                    component.attributes.searchedData = component.attributes.componentData
                    component.attributes.searchedData = component.attributes.componentData.filter((item) => {
                      return item.value.includes(event)
                    })
                  }
                })
              })
            })
          } else {
            ///// bayad inja search api i baraye input combobox benevisim felan chon niaz nist kari bahash nadarim b moghash minevisim
          }
        }
      })
    },
  },
}
</script>

<template>
  <b-form id="formBuilder" autocomplete="off">
    <div v-if="formData.length === 0">دیتایی وجود ندارد</div>
    <div class="d-flex flex-column align-items-center" v-else>
      <div v-for="section in formData" :key="section.cols" class="row" style="width: 100%">
        <div v-if="section.title" class="d-flex align-items-center mb-3 p-0">
          <div class="d-flex align-items-center">
            <span class="sectionTitle">{{ section.title }}</span>
          </div>
          <div class="line"></div>
        </div>
        <div :class="{ section: sectionBackground }">
          <div v-for="col in section.sectionData" :key="col.id" class="row">
            <!-- -------- just for spinner(select with number) -------------  -->
            <div v-if="col.diffrentCols === true" class="mb-3 spinner-4 col-4">
              <component :is="col[0].type" v-bind="col[0].attributes" v-model="inputsData[section.order].value" />
            </div>
            <div v-if="col.diffrentCols === true" class="mb-3 spinner-2 col-2">
              <component :is="col[1].type" v-bind="col[1].attributes" v-model="inputsData[section.order].value" />
            </div>
            <div v-if="col.diffrentCols === true" class="mb-3 spinner-4 col-4">
              <component :is="col[2].type" v-bind="col[2].attributes" v-model="inputsData[section.order].value" />
            </div>
            <div v-if="col.diffrentCols === true" class="mb-3 spinner-2 col-2">
              <component :is="col[3].type" v-bind="col[3].attributes" v-model="inputsData[section.order].value" />
            </div>
            <!-- ------------------- just for user information section ------------- -->
            <div v-if="col.userInformation === true">
              <b-row>
                <b-col class="d-flex justify-content-start align-items-center" lg="4">
                  <i class="fas fa-user-circle userPic"></i>
                  <div @click="$bvModal.show('chooseImage')" class="choosePic">انتخاب عکس</div>
                  <b-modal id="chooseImage" no-close-on-esc hide-footer centered size="lg" header-close-variant="dark" cancel-title>
                    <div class="p-3">
                      <Imagecropper />
                    </div>
                  </b-modal>
                </b-col>
                <b-col class="d-flex justify-content-start align-items-center" lg="4">
                  <FormTags :FormTagData="col.FormTagData" />
                </b-col>
                <b-col class="d-grid" lg="4">
                  <RangeSlider :modelValue="this.userDetails.customerSatisfactionRate" @rate="updateRate($event)" :options="sliderOptions" />
                </b-col>
              </b-row>
            </div>
            <!-- ------------------- General inputs ------------------- -->
            <div
              v-else
              v-for="inp in col.components"
              :key="inp.id"
              class="mb-3"
              :class="[col.cols === 1 ? 'col-12 col12padding' : col.cols === 2 ? 'col-6 col6padding' : col.cols === 3 ? 'col-4' : 'col-3']"
            >
              <keep-alive>
                <component
                  @productImage="imageCropper($event, inputsData[inp.order], inp)"
                  @rate="updateRate($event, inputsData[inp.order], inp)"
                  @fileBoxData="fileBoxData($event, inputsData[inp.order])"
                  @plaque="plaque($event, inputsData[inp.order])"
                  @selectedItem="selectedComboBox($event, inp.relations, inputsData[inp.order], formData)"
                  @searchedItem="searchedComboBox($event, inp.relations, inputsData[inp.order], formData)"
                  :is="inp.type"
                  v-bind="inp.attributes"
                  v-model="inputsData[inp.order].value"
                />
              </keep-alive>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <!-- <b-row :class="hasBottomMargin ? 'mb-3' : ''" style="width: 100%;"> -->
      <b-row style="width: 100%">
        <b-col class="deactiveUser" lg="4">
          <b-form-checkbox
            v-if="this.$router.name == 'list-user-detail'"
            id="checkbox-deactive-user-formbuilder"
            v-model="deactiveUserStatus"
            @change="deactiveUser"
            name="checkbox-deactive-user-formbuilder"
          >
            غیرفعال کردن کاربر
          </b-form-checkbox>
        </b-col>
        <b-col style="padding-left: 0" :class="{ buttonWithBackground: sectionBackground }" lg="8">
          <div class="buttonClass">
            <Button @click.native="onSubmit" text="ثبت و به روز رسانی" btnClass="ms-2 aprove btn-border" :loading="btnLoading" />
            <b-button @click="$bvModal.show('deleteUser')" v-if="deleteUser" class="deleteButton">
              <span class="deleteTitle">حذف کاربر</span>
              <i class="far fa-times-circle deleteTitle"></i>
            </b-button>
            <b-modal id="deleteUser" no-close-on-esc hide-footer headerClass="p-3 border-bottom-0" centered header-close-variant="dark" cancel-title>
              <div class="error-wrapper">
                <div class="mb-4">
                  <img src="@/assets/images/checked1.svg" />
                </div>
                <div class="error-title">آیا از حذف کاربر اطمینان دارید؟</div>
                <div class="buttons">
                  <div @click="$bvModal.hide('deleteUser')">
                    <button class="cancelButton">خیر</button>
                  </div>
                  <div>
                    <button class="approveButton">بلی</button>
                  </div>
                </div>
              </div>
            </b-modal>
            <b-button @click="$bvModal.show('cancleModal')" v-if="cancleForm" class="cancleButton">
              <span class="cancleTitle">انصراف</span>
            </b-button>
            <b-modal id="cancleModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
              <div class="error-wrapper">
                <div class="mb-4">
                  <img src="@/assets/images/checked1.svg" />
                </div>
                <div class="error-title">آیا از انصراف خود مطمئن هستید؟</div>
                <div class="buttons">
                  <div @click="$bvModal.hide('cancleModal')">
                    <button class="cancelButton">خیر</button>
                  </div>
                  <div @click="cancleButton">
                    <button class="approveButton">بلی</button>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>
<style lang="scss" scoped>
::v-deep .vue-slider-rtl .vue-slider-mark-label {
  margin-top: 3px !important;
}
::v-deep .modal-dialog {
  max-width: 540px !important;
}
::v-deep .modal-backdrop {
  background-color: rgba(19, 19, 19, 0.9) !important;
}
.rowStyle {
  margin-bottom: 20px;
  display: flex;
}
.deleteButton {
  padding: 10px 5px 10px 10px;
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #ffffff;
  border: 1px solid #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.col12padding {
  padding: 0 !important;
}
.col6padding:first-child {
  padding-right: 0 !important;
}
.col6padding:last-child {
  padding-left: 0 !important;
}
.deleteTitle {
  color: gray;
  margin-right: 5px;
}
.buttonWithBackground {
  padding-left: 0;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.cancleTitle {
  color: white;
  margin-right: 5px;
}
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.aprove {
  background-color: #556ee6 !important;
  padding: 10px 15px !important;
}
.btn-border {
  border-radius: 4px !important;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.spinner-4 {
  padding: 0 10px 0 0 !important;
}
.spinner-2 {
  padding: 0 15px 0 12px !important;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}
.userPic {
  font-size: 60px;
  color: #556ee6;
}
.choosePic {
  display: flex;
  cursor: pointer;
  margin-right: 30px;
  justify-content: center;
  align-items: center;
  color: white;
  background: #556ee6;
  border-radius: 2.6px;
  width: 99px;
  height: 28px;
}
.deactiveUser {
  display: flex;
  align-items: center !important;
  padding-right: 0;
}
::v-deep .custom-control-input {
  margin-left: 9px;
  border-radius: 4px;
}
::v-deep .custom-control-label {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
::v-deep .custom-control {
  display: flex;
  align-items: center;
}
.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
</style>
